import operators from "./operators";
import definitions from "./definitions";
/*
category: friendlyName of table
table: actual table name
fullTableName: incase if i need to send this when switching between modes to prepopulate the fields
column: actually name of column used for fields with no filters
friendlyName: used for fields and filters
translation: translates the filter into plain english
queryBuilderJSON: filter rules
distinctValueJSON: this will fire 
*/
const version = "1.0";
const globalLimit = 1000;
const db = "OBSURV-OBESITY";
const dbType = "Snowflake";
const patientTableName = "OBESITY.PATIENT_SUMMARY";
const patientKey = 'OBESITY.PATIENT_SUMMARY.PATIENT_KEY';

const data = {
  version,
  globalLimit,
  db,
  patientTableName,
  getDistinctCptCodes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "OBESITY.CPT.CPT_CODE",
        },
        {
          columnName: "OBESITY.CPT.CPT_DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd9Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "OBESITY.ICD9.CODE",
        },
        {
          columnName: "OBESITY.ICD9.SHORT_DESCRIPTION",
        },
        {
          columnName: "OBESITY.ICD9.DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd10Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "OBESITY.ICD10.ICD_10_CODE",
        },
        {
          columnName: "OBESITY.ICD10.SHORT_DESCRIPTION",
        },
        {
          columnName: "OBESITY.ICD10.LONG_DESCRIPTION",
        },
      ],
    };
  },
  queryItems: [
    {
      category: "Allergy History",
      table: "ALLERGY",
      fullTableName: "OBESITY.ALLERGY_HISTORY",
      friendlyName: "Allergy",
      key: "ALLERGY_DESCRIPTION",
      column: "OBESITY.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.allergy.definition,
        example: definitions.allergy.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.ALLERGY_HISTORY.ALLERGY_DESCRIPTION";
          },
          friendlyName: "Allergy",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                },
                // {
                //   columnName: "DH_CRC.CRC_CV_D_ALLERGY.ALLERGY_KEY",
                // }
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Allergy History",
          table: "ALLERGY HISTORY",
          fullTableName: "OBESITY.ALLERGY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Reaction",
          key: "REACTION",
          column: "OBESITY.ALLERGY_HISTORY.REACTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.64453024205661451",
              field: (props) => {
                return "OBESITY.ALLERGY_HISTORY.REACTION";
              },
              friendlyName: "Reaction",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.ALLERGY_HISTORY.REACTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Patient Demographics",
      table: "PATIENT",
      fullTableName: "OBESITY.PATIENT",
      friendlyName: "Patient Gender",
      key: "GENDER",
      column: "OBESITY.PATIENT_SUMMARY.GENDER",
      dataType: "TEXT",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.patientDemographics.definition,
        example: definitions.patientDemographics.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PATIENT_SUMMARY.GENDER";
          },
          friendlyName: "Patient Gender",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PATIENT_SUMMARY.GENDER",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "OBESITY.PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Birth Year",
          key: "BIRTH_YEAR",
          column: "OBESITY.PATIENT_SUMMARY.BIRTH_YEAR",
          not: false,
          dataType: "DATE",
          operator: "=",
          //grid: 12,
          isChildFilterNumeric: true,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PATIENT_SUMMARY.BIRTH_YEAR";
              },
              friendlyName: "Patient Age",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PATIENT_SUMMARY.BIRTH_YEAR",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "OBESITY.PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Patient Age",
          key: "AGE",
          column: "OBESITY.PATIENT_SUMMARY.AGE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 12,
          isChildFilterNumeric: true,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PATIENT_SUMMARY.AGE";
              },
              friendlyName: "Patient Age",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PATIENT_SUMMARY.AGE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        // {
        //   category: "Patient Demographics",
        //   table: "PATIENT",
        //   fullTableName: "OBESITY.PATIENT_SUMMARY",
        //   parentTable: "PATIENT",
        //   friendlyName: "Marital Status",
        //   key: "MARITAL_STATUS",
        //   column: "OBESITY.PATIENT_SUMMARY.MARITAL_STATUS",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   //grid: 6,
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "OBESITY.PATIENT_SUMMARY.MARITAL_STATUS";
        //       },
        //       friendlyName: "Marital Status",
        //       operators: operators.text,
        //       distinctValueJSON: (columnValue, phrase = null) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName: "OBESITY.PATIENT_SUMMARY.MARITAL_STATUS",
        //             },
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field: "OBESITY.PATIENT_SUMMARY.GENDER",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       any: false,
        //       dataType: "TEXT",
        //     },
        //   ],
        // },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "State",
          key: "STATE_CODE",
          column: "OBESITY.PATIENT_SUMMARY.STATE_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PATIENT_SUMMARY.STATE_CODE";
              },
              friendlyName: "State",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PATIENT_SUMMARY.STATE_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Zip Code",
          key: "ZIP",
          column: "OBESITY.PATIENT_SUMMARY.ZIP",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PATIENT_SUMMARY.ZIP";
              },
              friendlyName: "Zip Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PATIENT_SUMMARY.ZIP",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Race",
          key: "RACE",
          column: "OBESITY.PATIENT_SUMMARY.RACE_DESCRIPTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PATIENT_SUMMARY.RACE_DESCRIPTION";
              },
              friendlyName: "Race",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PATIENT_SUMMARY.RACE_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Lab Tests",
      table: "LAB_RESULT",
      fullTableName: "OBESITY.LAB_RESULTS",
      parentTable: "PATIENT",
      friendlyName: "Lab Test Name",
      key: "TEST_NAME",
      column: "OBESITY.LAB_RESULTS.TEST_NAME",
      operator: "=",
      hasEndingLabel: true,
      endingLabelKey: "UOM",
      props: [],
      isChildFilterNumeric: false,
      columns: [
        {
          column: "OBESITY.LAB_RESULTS.TEST_NAME",
          key: "TEST_NAME",
          friendlyName: "Test Name",
        },
        {
          column: "OBESITY.LAB_RESULTS.LOINC_TEST_CODE",
          key: "LOINC_TEST_CODE",
          friendlyName: "Loinc Test Code",
        },
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.labResult.definition,
        example: definitions.labResult.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.64453130566821",
          field: "OBESITY.LAB_RESULTS.TEST_NAME",
          friendlyName: "Lab Observation",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.LAB_RESULTS.TEST_NAME",
                },
                {
                  columnName: "OBESITY.LAB_RESULTS.LOINC_TEST_CODE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "OBESITY.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Unit of Measure",
          key: "UOF_M",
          column: "OBESITY.LAB_RESULTS.UOF_M",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.LAB_RESULTS.UOF_M";
              },
              friendlyName: "Unit of Measure",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.LAB_RESULTS.UOF_M",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "OBESITY.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Reference Ranges",
          key: "REFERENCE_RANGES",
          column: "OBESITY.LAB_RESULTS.REFERENCE_RANGES",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.LAB_RESULTS.REFERENCE_RANGES";
              },
              friendlyName: "Reference Ranges",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.LAB_RESULTS.REFERENCE_RANGES",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "OBESITY.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Lab Text Value",
          key: "OBSERVATION_VALUE_TEXT",
          column: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "OBESITY.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Lab Numeric Value",
          key: "OBSERVATION_VALUE_NUMERIC",
          column: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "NUMBER",
            },
          ],
        },
      ],
    },
    {
      category: "Chief Complaint History",
      table: "CHIEF_COMPLAINT_HISTORY",
      fullTableName: "OBESITY.CHIEF_COMPLAINT_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Chief Complaint",
      key: "CHIEF_COMPLAINT",
      column: "OBESITY.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.chiefComplaint.definition,
        example: definitions.chiefComplaint.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT";
          },
          friendlyName: "Chief Complaint",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Chief Complaint History",
          table: "CHIEF_COMPLAINT_HISTORY",
          fullTableName: "OBESITY.CHIEF_COMPLAINT_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "OBESITY.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Reported Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "OBESITY.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Diagnosis History",
      table: "DIAGNOSIS_HISTORY",
      fullTableName: "OBESITY.DIAGNOSIS_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Diagnosis Description",
      key: "ICD_DESCRIPTION",
      column: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
      operator: "=",
      columns: [
        {
          column: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
          key: "ICD_DESCRIPTION",
          friendlyName: "ICD Description",
          showInFilter: false,
        },
        {
          column: "OBESITY.DIAGNOSIS_HISTORY.PROBLEM_ICD",
          key: "PROCLEM_ICD",
          friendlyName: "ICD Code",
          primary: true
        },
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.diagnosisHistory.definition,
        example: definitions.diagnosisHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION";
          },
          friendlyName: "Diagnosis Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                },
                {
                  columnName: "OBESITY.DIAGNOSIS_HISTORY.PROBLEM_ICD",
                },
                {
                  columnName: "OBESITY.DIAGNOSIS_HISTORY.ICD_TYPE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "OBESITY.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Date",
          key: "DATE_ACTIVE",
          column: "OBESITY.DIAGNOSIS_HISTORY.DATE_ACTIVE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.DIAGNOSIS_HISTORY.DATE_ACTIVE";
              },
              friendlyName: "Diagnosis Date",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.DIAGNOSIS_HISTORY.DATE_ACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DATE_ACTIVE",
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "OBESITY.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "ICD Type",
          key: "ICD_TYPE",
          column: "OBESITY.DIAGNOSIS_HISTORY.ICD_TYPE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.DIAGNOSIS_HISTORY.ICD_TYPE";
              },
              friendlyName: "Diagnosis Code System",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.DIAGNOSIS_HISTORY.ICD_TYPE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "OBESITY.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Code",
          key: "PROBLEM_ICD",
          column: "OBESITY.DIAGNOSIS_HISTORY.PROBLEM_ICD",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.DIAGNOSIS_HISTORY.PROBLEM_ICD";
              },
              friendlyName: "Diagnosis Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.DIAGNOSIS_HISTORY.PROBLEM_ICD",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "OBESITY.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Snowmed Code Description",
          key: "SNOMED",
          column: "OBESITY.DIAGNOSIS_HISTORY.SNOMED",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.DIAGNOSIS_HISTORY.SNOMED";
              },
              friendlyName: "Diagnosis Status",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.DIAGNOSIS_HISTORY.SNOMED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "SNOMED",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "DRM Data",
      table: "DRMDATA",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
      parentTable: "PATIENT",
      friendlyName: "Report Name",
      key: "REPORT_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME";
          },
          friendlyName: "Report Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Report Date",
          key: "REPORT_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE";
              },
              friendlyName: "Report Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Study Date",
          key: "STUDY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE";
              },
              friendlyName: "Study Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Data Category",
          key: "DATA_CATEGORY",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY";
              },
              friendlyName: "Report Name",
              operators: operators.text,
              parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DATA_CATEGORY",
              any: null,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Family History",
      table: "FAMILY_HISTORY",
      fullTableName: "OBESITY.FAMILY_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Family History",
      key: "FAMILY_HISTORY",
      column: "OBESITY.FAMILY_HISTORY.FAMILY_HISTORY",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.familyHistory.definition,
        example: definitions.familyHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.FAMILY_HISTORY.FAMILY_HISTORY";
          },
          friendlyName: "Family Member",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.FAMILY_HISTORY.FAMILY_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Family History",
          table: "FAMILY_HISTORY",
          fullTableName: "OBESITY.FAMILY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.FAMILY_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "OBESITY.FAMILY_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.FAMILY_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.FAMILY_HISTORY.FAMILY_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Medication History",
      table: "MED_NAME",
      fullTableName: "OBESITY.MEDICATION_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Medication Name",
      key: "MED_NAME",
      column: "OBESITY.MEDICATION_HISTORY.MED_NAME",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.medicationHistory.definition,
        example: definitions.medicationHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.MEDICATION_HISTORY.MED_NAME";
          },
          friendlyName: "Medication Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          selectOptionsColumn: "MED_NAME",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Specialty",
          key: "SPECIALTY",
          column: "OBESITY.MEDICATION_HISTORY.SPECIALTY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.SPECIALTY";
              },
              friendlyName: "Specialty",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.SPECIALTY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Start Date",
          key: "DATE_INITIATED",
          column: "OBESITY.MEDICATION_HISTORY.DATE_INITIATED",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.DATE_INITIATED";
              },
              friendlyName: "Start Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.DATE_INITIATED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Stop Date",
          key: "DATE_INACTIVATED",
          column: "OBESITY.MEDICATION_HISTORY.DATE_INACTIVATED",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.DATE_INACTIVATED";
              },
              friendlyName: "Stop Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.DATE_INACTIVATED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "<=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "RxNorm ID",
          key: "RXNORM_ID",
          column: "OBESITY.MEDICATION_HISTORY.RXNORM_ID",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.RXNORM_ID";
              },
              friendlyName: "Medication Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.RXNORM_ID",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "RXNORM_ID",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Medication Strength",
          key: "STRENGTH",
          column: "OBESITY.MEDICATION_HISTORY.STRENGTH",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.STRENGTH";
              },
              friendlyName: "Medication Strength",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.STRENGTH",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                  orderBys: [
                    {
                      column: "OBESITY.MEDICATION_HISTORY.STRENGTH",
                      direction: "asc",
                    },
                  ],
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              selectOptionsColumn: "STRENGTH",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Route Of Administration",
          key: "ROUTE",
          column: "OBESITY.MEDICATION_HISTORY.ROUTE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.ROUTE";
              },
              friendlyName: "Route of Administration",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.ROUTE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Form",
          key: "DOSAGE_FORM",
          column: "OBESITY.MEDICATION_HISTORY.DOSAGE_FORM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 6,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.DOSAGE_FORM";
              },
              friendlyName: "Form",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.DOSAGE_FORM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "OBESITY.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Not Active",
          key: "INACTIVE",
          column: "OBESITY.MEDICATION_HISTORY.INACTIVE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.MEDICATION_HISTORY.INACTIVE";
              },
              friendlyName: "Is Active",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.MEDICATION_HISTORY.INACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Past Medical History",
      table: "PAST_MEDICAL_HISTORY",
      fullTableName: "OBESITY.PAST_MEDICAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Past Medical Answer",
      key: "PAST_MEDICAL_HISTORY",
      column: "OBESITY.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.pastMedicalHistory.definition,
        example: definitions.pastMedicalHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Past Medical History",
          table: "PAST_MEDICAL_HISTORY",
          fullTableName: "OBESITY.PAST_MEDICAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "OBESITY.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Procedure History",
      table: "PROCEDURE",
      fullTableName: "OBESITY.PROCEDURE_HISTORY",
      parentTable: "PATIENT_SUMMARY",
      friendlyName: "Procedure",
      key: "CPT_KEY",
      column: "OBESITY.PROCEDURE_HISTORY.CPT_KEY",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.procedureHistory.definition,
        example: definitions.procedureHistory.example,
      },
      columns: [
        {
          column: "OBESITY.PROCEDURE_HISTORY.CPT_KEY",
          key: "CPT_KEY",
          friendlyName: "CPT Key",
        },
        {
          column: "OBESITY.PROCEDURE_HISTORY.CPT_DESCRIPTION",
          key: "CPT_DESCRIPTION",
          friendlyName: "CPT Description",
        },
      ],
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PROCEDURE_HISTORY.CPT_KEY";
          },
          friendlyName: "Procedure Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PROCEDURE_HISTORY.CPT_KEY",
                },
                {
                  columnName: "OBESITY.PROCEDURE_HISTORY.CPT_DESCRIPTION",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          selectOptionsColumn: "PROCEDURE_DESCRIPTION",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "OBESITY.PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Procedure Date",
          key: "DATE_PERFORMED",
          column: "OBESITY.PROCEDURE_HISTORY.DATE_PERFORMED",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.PROCEDURE_HISTORY.DATE_PERFORMED";
              },
              friendlyName: "Procedure Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PROCEDURE_HISTORY.DATE_PERFORMED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PROCEDURE_HISTORY.CPT_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Review of System",
      table: "REVIEW_OF_SYSTEM",
      fullTableName: "OBESITY.REVIEW_OF_SYSTEMS_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Review of System Question",
      key: "REVIEW_OF_SYSTEMS",
      column: "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.reviewOfSystems.definition,
        example: definitions.reviewOfSystems.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Review of System",
          table: "REVIEW_OF_SYSTEM",
          fullTableName: "OBESITY.REVIEW_OF_SYSTEMS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "OBESITY.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Social History",
      table: "SOCIAL_HISTORY",
      fullTableName: "OBESITY.SOCIAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Social History Question",
      key: "SOCIAL_HISTORY",
      column: "OBESITY.SOCIAL_HISTORY.SOCIAL_HISTORY",
      operator: "=",
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.socialHistory.definition,
        example: definitions.socialHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.SOCIAL_HISTORY.SOCIAL_HISTORY";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.SOCIAL_HISTORY.SOCIAL_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Social History",
          table: "SOCIAL_HISTORY",
          fullTableName: "OBESITY.SOCIAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.SOCIAL_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "OBESITY.SOCIAL_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.SOCIAL_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.SOCIAL_HISTORY.SOCIAL_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Vital Sign History",
      table: "VITAL_SIGN_HISTORY",
      fullTableName: "OBESITY.VITAL_SIGN_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Vital Sign Description",
      key: "VITAL",
      column: "OBESITY.VITAL_SIGN_HISTORY.VITAL",
      operator: "=",
      hasEndingLabel: false,
      //endingLabelKey: 'UNIT_OF_MEASURE',
      hiddenColumns: {
        VITAL: true,
        PATIENTCOUNT: true,
      },
      enableTooltip: true,
      tooltip: {
        definition: definitions.vitalSignHistory.definition,
        example: definitions.vitalSignHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.VITAL_SIGN_HISTORY.VITAL";
          },
          friendlyName: "Vital Sign Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.VITAL_SIGN_HISTORY.VITAL",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "OBESITY.VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Vital Sign Value",
          key: "VALUE",
          column: "OBESITY.VITAL_SIGN_HISTORY.VALUE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          //grid: 12,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.VITAL_SIGN_HISTORY.VALUE",
              friendlyName: "Vital Sign Value",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.VITAL_SIGN_HISTORY.VALUE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.VITAL_SIGN_HISTORY.VITAL",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "NUMBER",
            },
          ],
        },
      ],
    },
    {
      category: "Assessment",
      table: "ASSESSMENT",
      fullTableName: "OBESITY.ASSESSMENT",
      parentTable: "PATIENT",
      friendlyName: "Assessment",
      key: "ASSESSMENT",
      column: "OBESITY.ASSESSMENT.ASSESSMENT",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.assessment.definition,
        example: definitions.assessment.example,
      },
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.ASSESSMENT.ASSESSMENT";
          },
          friendlyName: "Assessment",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.ASSESSMENT.ASSESSMENT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Assessment",
          table: "ASSESSMENT",
          fullTableName: "OBESITY.ASSESSMENT",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "OBESITY.ASSESSMENT.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.ASSESSMENT.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.ASSESSMENT.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.ASSESSMENT.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "History of Present Illness",
      table: "HISTORY_OF_PRESENT_ILLNESS",
      fullTableName: "OBESITY.HISTORY_OF_PRESENT_ILLNESS",
      parentTable: "PATIENT",
      friendlyName: "Vital Sign Description",
      key: "HISTORY_OF_PRESENT_ILLNESS",
      column: "OBESITY.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.historyOfPresentIllness.definition,
        example: definitions.historyOfPresentIllness.example,
      },
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS";
          },
          friendlyName: "Vital Sign Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "OBESITY.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "History of Present Illness",
          table: "HISTORY_OF_PRESENT_ILLNESS",
          fullTableName: "OBESITY.HISTORY_OF_PRESENT_ILLNESS",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "OBESITY.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "OBESITY.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "OBESITY.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Physical Exam",
      table: "PHYSICAL_EXAM",
      fullTableName: "OBESITY.PHYSICAL_EXAM",
      parentTable: "PATIENT",
      friendlyName: "PHYSICAL_EXAM",
      key: "PHYSICAL_EXAM",
      column: "OBESITY.PHYSICAL_EXAM.PHYSICAL_EXAM",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.physicalExam.definition,
        example: definitions.physicalExam.example,
      },
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PHYSICAL_EXAM.PHYSICAL_EXAM";
          },
          friendlyName: "Phyiscal Exam",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PHYSICAL_EXAM.PHYSICAL_EXAM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Physical Exam",
          table: "PHYSICAL_EXAM",
          fullTableName: "OBESITY.PHYSICAL_EXAM",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "OBESITY.PHYSICAL_EXAM.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.PHYSICAL_EXAM.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PHYSICAL_EXAM.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PHYSICAL_EXAM.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Plan",
      table: "PLAN",
      fullTableName: "OBESITY.PLAN",
      parentTable: "PATIENT",
      friendlyName: "Plan",
      key: "PLAN",
      column: "OBESITY.PLAN.PLAN",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.plan.definition,
        example: definitions.plan.example,
      },
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PLAN.PLAN";
          },
          friendlyName: "Plan",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PLAN.PLAN",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Plan",
          table: "PLAN",
          fullTableName: "OBESITY.PLAN",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "OBESITY.PLAN.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.PLAN.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PLAN.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PLAN.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Pregnancy Comments",
      table: "PREGNANCY_COMMENTS",
      fullTableName: "OBESITY.PREGNANCY_COMMENTS",
      parentTable: "PATIENT",
      friendlyName: "PREGNANCY_COMMENTS",
      key: "PREGNANCY_COMMENTS",
      column: "OBESITY.PREGNANCY_COMMENTS.PREGNANCY_COMMENTS",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.pregnancyComments.definition,
        example: definitions.pregnancyComments.example,
      },
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "OBESITY.PREGNANCY_COMMENTS.PREGNANCY_COMMENTS";
          },
          friendlyName: "Pregnancy Comments",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PREGNANCY_COMMENTS.PREGNANCY_COMMENTS",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Pregnancy Comments",
          table: "PREGNANCY_COMMENTS",
          fullTableName: "OBESITY.PREGNANCY_COMMENTS",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "ENCOUNTER_DATE",
          column: "OBESITY.PREGNANCY_COMMENTS.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.PREGNANCY_COMMENTS.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "OBESITY.PREGNANCY_COMMENTS.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "OBESITY.PREGNANCY_COMMENTS.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Pregnancy Comments",
          table: "PREGNANCY_COMMENTS",
          fullTableName: "OBESITY.PREGNANCY_COMMENTS",
          parentTable: "PATIENT",
          friendlyName: "Estimated Delivery Date",
          key: "ESTIMATED_DELIVERY_DATE",
          column: "OBESITY.PREGNANCY_COMMENTS.ESTIMATED_DELIVERY_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "OBESITY.PREGNANCY_COMMENTS.ESTIMATED_DELIVERY_DATE",
              friendlyName: "Estimated Delivery Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "OBESITY.PREGNANCY_COMMENTS.ESTIMATED_DELIVERY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field:
                          "OBESITY.PREGNANCY_COMMENTS.ESTIMATED_DELIVERY_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Documents",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "Documents",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC CHF Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC CHF Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC AFIB Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC AFIB Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC PCI Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC PCI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC MI Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC MI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC EP Registry",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC EP Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "Payor",
      table: "PATIENT_PAYOR",
      fullTableName: "OBESITY.PATIENT_PAYOR",
      parentTable: "PATIENT",
      friendlyName: "Payor",
      key: "PAYOR",
      column: "OBESITY.PATIENT_PAYOR.INSURANCE_TYPE",
      operator: "=",
      hasEndingLabel: false,
      disabled: false,
      unstructured: false,
      enableTooltip: false,
      tooltip: {
        definition: "",
        example: "",
      },
      queryBuilderJSON: [
        {
          id: "r-0.64453024205443822",
          field: (props) => {
            return "OBESITY.PATIENT_PAYOR.INSURANCE_TYPE";
          },
          friendlyName: "Payor",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "OBESITY.PATIENT_PAYOR.INSURANCE_TYPE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
  ],
};

export default data;
